export class AzureManagementGroup {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementGroupId",
            "baseName": "managementGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonInternalResourceGroupName",
            "baseName": "eonInternalResourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "subscriptions",
            "baseName": "subscriptions",
            "type": "Array<AzureSubscription>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureManagementGroup.attributeTypeMap;
    }
    constructor() {
    }
}
